import {
  CardIcon,
  CashAppIcon,
  PayPalIcon,
  VenmoIcon,
  ZelleIcon,
} from '#/shared/ui/icons'
import {
  methodToChargeType,
  PAYMENT_METHOD,
} from '#/shared/ui/create-payment-modal'
import type { PaymentMethodType } from '#/shared/ui/create-payment-modal'

export const SETTLE_METHOD = {
  zelle: PAYMENT_METHOD.zelle,
  cashapp: PAYMENT_METHOD.cashapp,
  venmo: PAYMENT_METHOD.venmo,
  paypal: PAYMENT_METHOD.paypal,
  cash: PAYMENT_METHOD.cash,
  check: PAYMENT_METHOD.check,
  ach: PAYMENT_METHOD.ach,
  wire: PAYMENT_METHOD.wire,
} as const

export type SettleMethod = (typeof SETTLE_METHOD)[keyof typeof SETTLE_METHOD]

export const SETTLE_METHOD_ORDER: ReadonlyArray<SettleMethod> = [
  SETTLE_METHOD.zelle,
  SETTLE_METHOD.cashapp,
  SETTLE_METHOD.venmo,
  SETTLE_METHOD.paypal,
  SETTLE_METHOD.cash,
  SETTLE_METHOD.check,
  SETTLE_METHOD.ach,
  SETTLE_METHOD.wire,
]

export const SETTLE_METHOD_LABEL: Record<SettleMethod, string> = {
  [SETTLE_METHOD.zelle]: 'Zelle',
  [SETTLE_METHOD.cashapp]: 'Cash App',
  [SETTLE_METHOD.venmo]: 'Venmo',
  [SETTLE_METHOD.paypal]: 'PayPal',
  [SETTLE_METHOD.cash]: 'Cash',
  [SETTLE_METHOD.check]: 'Check',
  [SETTLE_METHOD.ach]: 'ACH',
  [SETTLE_METHOD.wire]: 'Wire',
}

type IconComponent = typeof ZelleIcon

export const METHOD_TYPE_ICON: Record<string, IconComponent | undefined> = {
  card: CardIcon,
  stripe: CardIcon,
  authorize_net: CardIcon,
  firstdata: CardIcon,
  zelle: ZelleIcon,
  cashapp: CashAppIcon,
  venmo: VenmoIcon,
  paypal: PayPalIcon,
}

export function isReceivableViaOther(type: PaymentMethodType): boolean {
  return methodToChargeType(type) !== PAYMENT_METHOD.card
}
